import { render, staticRenderFns } from "./book-table.vue?vue&type=template&id=c500a71e&"
import script from "./book-table.js?vue&type=script&lang=js&"
export * from "./book-table.js?vue&type=script&lang=js&"
import style0 from "./book-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./book-table.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports